import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {IrbEditor} from "@irb/irb-editors/irb-editors.base";
import {IEvent, IrbAppEvents, IrbEditorsEvents, IrbModelsEvents} from "@irb-common/events";
import {IModelDetailRequest, IModelDetailSaveResponse} from '@irb/irb-editors/irb-editors.model';
import {EditorModelService} from '@irb/irb-editors/editor-model/editor-model.service';
import {BlendedModelsAllocationService} from '@irb/irb-editors/editor-blended-model/blended-models-allocation.service';
import {IAlertDialogData,IApplyFilterOnLanding} from '@irb/app.model';
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import {HttpErrorResponse} from '@angular/common/http';
import {ModelsService, ICreateModel} from "@irb/irb-models/models-new/models.service";
import {Router} from "@angular/router";

import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
ModuleRegistry.registerModules([ AllCommunityModule ]);
import { AllEnterpriseModule } from 'ag-grid-enterprise';
ModuleRegistry.registerModules([AllEnterpriseModule]);


@Component({ standalone: false,
  selector: 'irb-editor-blended-model',
  templateUrl: './editor-blended-model.component.html',
  styleUrls: ['./editor-blended-model.component.scss', '../../irb-common/styles/dialog.scss', '../editor-sidebar/editor-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None
})
export class EditorBlendedModelComponent extends IrbEditor  {
  @ViewChild('body') body: ElementRef;
  
  modelEventData: any;
  defaultExpandedPanels: Array<string> = ['BLENDEDMODELHISTORY', 'MODALALLOCATIONS', 'BLSECURITYALLOCATIONS', 'BLSECURITYALLOCATIONSCHART'];
  showInLineeditFlag: boolean;
  showInLineEditDescFlag: boolean;
  tooltipMessage: any;
  tooltipDescMessage = 'Please provide valid model description.';
  historyData: any;
  modelStatus: string;
  noOfModels: number = 0;
  createModifyData: any = {};
  isRebalanceBtnEnabled: boolean = false;
  hasValidPortfolioRelation: boolean = false;
  blendedModalAllocationState: any = true;
  blendedSecAllocationState: any = true;
  blendedSecurityAllocationChartState: any = true;
  blendedAllocationHistoryState: any = false;
  eventPrevNextObject: any = null;
  isUiTest = false;
  slideOutTitle: string = 'Edit a Blended Model';
  showAllocationCustomView: boolean = false;
  mmcModelIds: any;
  redirectURL: string;
  window: any;
  isCopyModelEnabled: boolean;
  ENABLE_SEC_GRID_CHART: boolean;
  isSubscribeModel: boolean;
  isMMCAutomationEnabledFlag: boolean;
  autoRebalNotAllowed: boolean;
  autoRebalPaused: boolean;
  autoRebalAllowed: boolean;
  autoRebalPausedList: Array<any> = [];
  autoRebalNotAllowedList: Array<any> = [];
  allocationPanelOpened: boolean;
  pfCount: number = 0;
  modelUpdated: boolean = false;
  constructor(private cdr: ChangeDetectorRef,
              private editorModelService: EditorModelService,
              public bmas: BlendedModelsAllocationService,
              public ats: AnalyticsService,
              private readonly router: Router,
              private mos: ModelsService
            ) {
    super();
    this.identifier = 'modelId';
    this.redirectURL = this.as.getItem('IRB_APP_CONFIG')?.veoRedirectUrl;
    this.window = window;
    this.isCopyModelEnabled = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.isCopyModelEnabled || false;
    this.ENABLE_SEC_GRID_CHART = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_SEC_GRID_CHART || false;
    this.allocationPanelOpened = this.defaultExpandedPanels.includes("MODALALLOCATIONS");
  }
  get(event: IEvent) {
    this.isMMCAutomationEnabledFlag = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.MMCAutomationEnabled || false;
    this.historyData = null;
    super.get(event);
    this.ats.trackModelsEditBlendedModelEvent();
    this.ies.loadExpansionState(this.defaultExpandedPanels.length, "editor-blended-model", this.defaultExpandedPanels);
    this.modelEventData = event.data;
    this.mmcModelIds = event.data.mmcModelIds ? event.data.mmcModelIds : null;
    if (typeof this.modelEventData.rowIndex !== 'undefined') {
      this.eventPrevNextObject = {
        type: 'IRBMODELSEVENTS.SHOW_EDIT_MODEL',
        data: {
          fullscreen: this.modelEventData.fullscreen,
          rowIndex:this.modelEventData.rowIndex,
          isDraft:this.modelEventData.isDraft,
          approvedModelId: this.modelEventData.approvedModelId,
          slot: this.modelEventData.slot || null
        }
      }
    }

    const modelDetailsReq = {
      modelId: event.data.modelId,
      type: event.data.type,
      isDraft: event.data.isDraft,
      approvedModelId: event.data.approvedModelId
    };
    this.requestData(modelDetailsReq);
    this.ies.updateExpansionState('BLENDEDMODELHISTORY','closed');
    this.blendedModalAllocationState = this.ies.getDefaultExpansionState('MODALALLOCATIONS');
    this.blendedSecAllocationState = this.ies.getDefaultExpansionState('BLSECURITYALLOCATIONS');
    this.allocationPanelOpened = this.blendedModalAllocationState;
    this.setSlideOutTitle();
  }

  requestData(modelDetailsReq: any) {
    this.editorModelService.clearAll();
    this.bmas.setAllocationSecurities(null);
    this.ies.getModelDetailsForEditModel(modelDetailsReq).subscribe((data: any) => {
      if (data && data.blendModelDTO) {
        this.modelStatus = data.blendModelDTO.status;
        if (data.blendModelDTO.blendedSecurityModelAssociationsList) {
          this.autoRebalAllowed = true;
          this.autoRebalPaused = false;
          this.autoRebalNotAllowed = false;
          this.autoRebalPausedList = [];
          this.autoRebalNotAllowedList = [];
          data.blendModelDTO.blendedSecurityModelAssociationsList.forEach((x: any) => {
            if (x.securityModelDTO?.allowAutoRebalOnModelUpdate === 'PAUSED_FOR_REV') {
              this.autoRebalPaused = true;
              this.autoRebalAllowed = false;
              this.autoRebalPausedList.push(x.securityModelDTO);
            } else if (x.securityModelDTO?.allowAutoRebalOnModelUpdate === 'NOT_ALLOWED') {
              this.autoRebalNotAllowed = true;
              this.autoRebalAllowed = false;
              this.autoRebalNotAllowedList.push(x.securityModelDTO);
            }
            if (x.securityModelDTO?.isSubscribed) {
              this.isSubscribeModel = true;
            }
          });
        }
        this.load(data.blendModelDTO as any);

        this.bmas.getGlobalSettings(data.blendModelDTO);
      }
    }, () => {
      this.load({});
    });
  }

  private setSlideOutTitle() {
    this.slideOutTitle = this.modelEventData.isDraft ? 'Create a Blended Model' : 'Edit a Blended Model'
  }

  load(data: any) {
    data.noOfSecurities = 0;
    if (data.blendedSecurityModelAssociationsList) {
      this.noOfModels = data.blendedSecurityModelAssociationsList.length;
      data.noOfSecurities = this.bmas.getNoDuplicateSecuritiesCount(data.blendedSecurityModelAssociationsList);
    }
    this.createModifyData = {
      createdDate: data.createdDate,
      createdBy: data.createdBy,
      modifiedDate: data.modifiedDate,
      modifiedBy: data.modifiedBy,
      historyLastModifiedBy: data.historyLastModifiedBy,
      lastModifiedHistoryDate: data.lastModifiedHistoryDate,
      modelName: data.blendedSecurityModelName
    };

    this.pfCount = data.pfCount;
    this.showInLineeditFlag = false;
    this.showInLineEditDescFlag = false;
    this.tooltipMessage = '';
    super.load(data);
    if (this.showUnsavedChangesWarning) {
      this.closeWithoutSave();
    }
    this.setEditorModelHeight();
    setTimeout(() => {
      this.setEditorModelHeight();
    },100);
    this.getModelRelations();

    if(this.modelEventData.copyOnLoad) {
      this.copyModelProceed();
    }
  }

  private getTotalPercent() {
    let total: number = 0;
    if (this.data && this.data.blendedSecurityModelAssociationsList) {
      const modals: any = this.data.blendedSecurityModelAssociationsList;
      modals.forEach((modal: any) => {
        if (!modal.securityModelDTO.isUIdeleted) {
          total += modal.securityModelDTO.modelPercent ? Number(modal.securityModelDTO.modelPercent) : 0;
        }
      });
      total = Number(total.toFixed(1));
    }
    return total;
  }

  private setValidity() {
    let isValidValue: boolean = true;
    if (this.data && this.data.blendedSecurityModelAssociationsList) {
      const modals: any = this.data.blendedSecurityModelAssociationsList;
      modals.forEach((modal: any) => {
        if (!modal.securityModelDTO.isUIdeleted) {
          const per: number = modal.securityModelDTO.modelPercent ? Number(modal.securityModelDTO.modelPercent) : 0;
          if (per < 0 || per > 100) {
            isValidValue = false;
          }
        }
      });
    }
    this.isValid = isValidValue;
  }
  onOpenHistoryPanel() {
    this.ies.updateExpansionState('BLENDEDMODELHISTORY','opened');
    if (this.modelEventData && !this.historyData) {
      this.ies.getBlendedModelHistory(this.modelEventData.modelId).subscribe((historyData: any) => {
        this.historyData = historyData;
      });
    }
  }
  onCloseHistoryPanel() {
    this.ies.updateExpansionState('BLENDEDMODELHISTORY','closed');
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setEditorModelHeight();
  }

  private setEditorModelHeight() {
    if (this.body) {
      const rect = this.body.nativeElement.getBoundingClientRect();
      let h = (window.innerHeight - rect.top - 10);

      h = (h < 200) ? 200 : h;
      this.bodyHeight = h + 'px';
    }
  }

  processEvent(event: IEvent) {
    super.processEvent(event);
    switch (event.type) {
      case IrbModelsEvents.MODEL_ALLOCATION_REFRESH:
      const requestData: any = {
        modelId: this.data.blendedSecurityModelId,
        type: this.data.modelType,
        isDraft: false,
        approvedModelId: null
      };
      this.requestData(requestData);
      break;
  }
  this.cdr.detectChanges();
  }

  onInputChange() {
    const ignore: Array<string> = [
      "securityModelAllocationList"
    ];

    super.onInputChange(ignore);
    this.setValidity();
    this.cdr.detectChanges();
  }

  saveInlineDescEdit(blendedSecurityModelDescription: any) {
    this.data.blendedSecurityModelDescription = blendedSecurityModelDescription;
    this.showInLineEditDescFlag = false;
    this.onInputChange();
  }

  showInlineEdit() {
    this.showInLineeditFlag = true;
    this.cdr.detectChanges();
  }

  showInlineDescEdit() {
    this.showInLineEditDescFlag = true;
    this.cdr.detectChanges();
  }

  onTextChange() {
    this.tooltipMessage = '';
  }

  saveInlineEdit(blendedSecurityModelName: any) {
    if (blendedSecurityModelName.trim() === '') {
      this.closeInlineEdit();
      return;
    }
    this.ies.validateSecurityModelName(blendedSecurityModelName, 'Blended').subscribe((data: any) => {
      if (!data.data) {
        this.tooltipMessage = '';
        this.data.blendedSecurityModelName = blendedSecurityModelName;
        this.showInLineeditFlag = false;
        this.onInputChange();
      } else {
        this.tooltipMessage = 'This Blended Model name already exists.  Please enter a different name.';
      }
    });
  }
  closeInlineEdit() {
    this.tooltipMessage = '';
    this.data.blendedSecurityModelName = super.getOriginalData().blendedSecurityModelName;
    this.onInputChange();
    this.showInLineeditFlag = false;
    this.cdr.detectChanges();
  }
  closeInlineDescEdit() {
    this.data.blendedSecurityModelDescription = super.getOriginalData().blendedSecurityModelDescription;
    this.onInputChange();
    this.showInLineEditDescFlag = false;
    this.cdr.detectChanges();
  }


  private buildSavingObject() {

    const savingObj: any = JSON.parse(JSON.stringify(this.data));
    delete savingObj.noOfSecurities;
    savingObj.blendedSecurityModelAssociationsList.forEach((model: any) => {
      model.securityModelDTO = {
        securityModelId: model.securityModelDTO.securityModelId,
        modelPercent: model.securityModelDTO.modelPercent ? Number(model.securityModelDTO.modelPercent) : 0,
        isNew: model.securityModelDTO.isNew || false,
        isUIdeleted: model.securityModelDTO.isUIdeleted || false
      };
      delete model.modelPercent;
      delete model.isNew;
      delete model.isUIdeleted;
      delete model.blendedSecurityModelAssociationId;
      delete model.blendedSecurityModelId;
    });
    if (!savingObj.listOfPortfolios) {
      savingObj.listOfPortfolios = [];
    }
    return savingObj;
  }

  private getModelRelations() {
    if (this.data && this.data.blendedSecurityModelId) {
      const total = this.getTotalPercent();
      const modelDetail: IModelDetailRequest = {
        modelId: this.data.blendedSecurityModelId,
        type: 'Blended',
      };
      this.ies.getModelAssociationDetails(modelDetail).subscribe((res: any) => {
        this.isRebalanceBtnEnabled = total === 100 && res.hasValidPortfolioRelation;
        this.hasValidPortfolioRelation = res.hasValidPortfolioRelation;
      });
    }
  }

  save() {
    this.ats.trackClickEvent("lc_editblendsave");
    if (this.hasValidPortfolioRelation && this.getTotalPercent() !== 100) {
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: 'error',
        summary: 'Targets must equal 100%',
        detail: 'This model\'s security targets do not add up to 100%. You will be unable to save these changes since this model is associated with portfolio(s). Please update the targets to add up to 100% in order to proceed.'
      });
      return;
    }

    //is copy model
    if(this.data.blendedSecurityModelId == -1) {
      this.checkSecurityModelName(() => {
        this.completeSave();
      });
    } else {
      this.completeSave();
    }
  }

  completeSave() {
    this.as.fireEvent(IrbEditorsEvents.SAVE_START, { "slot": this.slot });
    this.ies.saveBlendedModel(this.buildSavingObject()).subscribe((response: IModelDetailSaveResponse) => {
        //is copy model
        if(this.data.blendedSecurityModelId == -1) {
          this.data.blendedSecurityModelId = response.responseData.modelId;
          this.data.versionId = response.responseData.modifiedVersion;
          this.data.modifiedDate = response.responseData.modifiedDate;
          this.data.modifiedBy = response.responseData.modifiedBy;
        }

      if (response.responseStatus === 'SUCCESS') {
        const modelDetailsReq = {
          modelId: this.data.blendedSecurityModelId,
          type: this.data.modelType,
          isDraft: false,
          approvedModelId: null
        } as IModelDetailRequest;
        this.modelUpdated = true;
        if (this.modelEventData?.parentObj) {
          this.modelEventData.parentObj.reloadAfterModelClosed = true;
        }
        this.ies.getModelDetailsForEditModel(modelDetailsReq).subscribe((data: any) => {
          if (data && data.blendModelDTO) {
            this.modelStatus = data.blendModelDTO.status;

            let toastDetail = this.modelEventData.isDraft ? '1 model was created.' : 'Model updated.';
            let totalAllocation: any = this.bmas.getTotalPercentForBlended();
            if (Number(totalAllocation) !== 100) {
              toastDetail = 'To use this model, allocations must equal 100%.';
              this.as.fireEvent(IrbEditorsEvents.WARN_SUCCESS, {
                'hasPendingFunction': this.hasPendingFunction,
                'data': toastDetail,
                'summary': 'Incomplete Blended Model',
                'slot': this.slot,
                removeOnClose: true
              });
            } else {
              let toastSummary = this.modelEventData.isDraft ? 'Create Blended Model' : null;
              this.as.fireEvent(IrbEditorsEvents.SAVE_SUCCESS, {
                'hasPendingFunction': this.hasPendingFunction,
                'data': (this.modelEventData.isCopy) ? "A copy of your model has been created" : toastDetail,
                'summary': toastSummary,
                'slot': this.slot,
                removeOnClose: true
              });
            }
            this.modelEventData.isDraft = false;
            this.modelEventData.isCopy = false;
            this.setSlideOutTitle();
            this.load(data.blendModelDTO as any);

            this.ies.getBlendedModelHistory(this.data.blendedSecurityModelId).subscribe((historyData: any) => {
              this.historyData = historyData;
            });
          }
          this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
          this.as.fireEvent(IrbAppEvents.GRID_REFRESH, { 'slot': this.slot });
        });
      } else if (response.responseStatus === "BUSINESS_ERR_MSG" || response.responseStatus === "EXCEPTION") {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: "error",
          summary: "Please refresh Page",
          detail: "Exception occurred",
        });
        this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
        if (!this.isUiTest) {
          throw new Error('Editor Blended Model save failed. modelId=' + this.data.blendedSecurityModelId);
        }
      } else if (response.responseStatus === 'STALEDATAEXCEPTION') {
        this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
        this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
            dTitle: 'Refresh Required',
            dProceedBtnLabel: 'Refresh',
            msg: "You are attempting to edit a model that was just modified by someone else. To see the updated model, you need to refresh the page.",
            onProceed: () => {this.refreshEditModel()}
        } as IAlertDialogData);
      }
    }, (err: HttpErrorResponse) => {
      this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { 'slot': this.slot });
      let m = err.message ? err.message : 'Editor Blended Model save failed.';
      m += ' modelId=' + this.data.blendedSecurityModelId;
      throw new Error(m);
    });
  }

  refreshEditModel() {
      const modelDetailsReq = {
          modelId: this.data.blendedSecurityModelId,
          type: this.data.modelType,
          isDraft: false,
          approvedModelId: null
      } as IModelDetailRequest;

      this.ies.getModelDetailsForEditModel(modelDetailsReq).subscribe((data: any) => {
          if (data && data.blendModelDTO) {
              this.modelStatus = data.blendModelDTO.status;
              this.load(data.blendModelDTO as any);
              this.ies.getBlendedModelHistory(this.data.blendedSecurityModelId).subscribe((historyData: any) => {
                  this.historyData = historyData;
              });
              setTimeout(()=> {
                this.bmas.changeData();
              }, 200);

          }
      });
  }

  onCreateRebalance() {
    this.ats.trackClickEvent("lc_editblendrebal");
    
    const crConfig: any = {
      parentComponent: 'editor-blended-model',
      parentComponentThis: this,
      modelId: this.data.blendedSecurityModelId + 'b',
      modelName: this.data.blendedSecurityModelName,
      closeParentBeforeNavigate: true
    };

    crConfig.hasValidPortfolioRelationToModel = this.hasValidPortfolioRelation;
    crConfig.allowRebalanceSubmit = this.hasValidPortfolioRelation;
    this.as.fireEvent('createRebalance', crConfig);
  }

  onCopyModel() {
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
      dTitle: 'Create a copy',
      dProceedBtnLabel: 'Yes',
      dCancelBtnLabel: "No",
      msg: "iRebal will create a copy of this model. Do you want to proceed?",
      onProceed: () => {this.copyModelProceed()}
    } as IAlertDialogData);
  }

  copyModelProceed() {
    const r = {} as ICreateModel;
    r.modelType = "Blended";
    r.modelName = "Copy of " + this.data.blendedSecurityModelName;
    r.modelDescription = this.data.blendedSecurityModelDescription;

    this.modelEventData.isCopy = true;
    this.modelEventData.copyOnLoad = false;
    this.modelEventData.modelId = -1;
    this.data.parentModelId = this.data.blendedSecurityModelId;
    this.data.blendedSecurityModelId = -1;
    this.data.blendedSecurityModelName = r.modelName;
    this.data.versionId = 0;
    this.data.createdDate = null;
    this.data.createdBy = null;
    this.data.modifiedDate = null;
    this.data.modifiedBy = null;
    this.historyData = [];

    this.data.blendedSecurityModelAssociationsList.forEach((x: any) => {
      x.securityModelDTO.isNew = true;
    });

    this.onInputChange();
  }

  checkSecurityModelName(proceedCbFunc: Function) {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

    this.ies.validateSecurityModelName(this.data.blendedSecurityModelName, "Blended").subscribe((data: any) => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);

      if (data.data === true) {
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          dType: 'ERROR',
          msg: 'Model name is already in use. Please provide another one.'
        });
      } else {
        proceedCbFunc();
      }
    });
  }
  showPortfoliosByModel() {
    if (this.isModified) { return;}
    const state:IApplyFilterOnLanding = {
      isUpdatRequired : true,
      filterModel : {name:'securityModelName', value:[this.data.blendedSecurityModelName], isUpdatRequired:true}
    } as IApplyFilterOnLanding;
    if (this.router.url === '/clients/portfolios') {
      this.router.navigateByUrl('/', { skipLocationChange: true}).then(() => {
        this.router.navigateByUrl('/clients/portfolios', { state: state });
      });
    } else {
      this.router.navigateByUrl('/clients/portfolios', { state: state });
    }
  }
  openSecurityModel(data: any){
      data.fullscreen = true;
      data.showNextPrev =  false;
      data.typeModel =  "Security";
      data.type =  "Base";
      data.modelId = data.securityModelId;
      data.isDraft = false;
      data.approvedModelId = null;
      data.slot = "C";
      data.openFromBlended=true;
      this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MODEL, data);
  }
  cancel() {
    if (this.modelEventData?.parentObj) {
      if (this.modelEventData?.parentObj?.reloadAfterModelClosed) {
        if (this.modelEventData?.parentObj?.multiplePortfolioEditRequest) {
          this.modelEventData.parentObj.closeAndReopen(this.modelEventData.parentObj.multiplePortfolioEditRequest);
        } else {
          if (this.modelEventData?.parentObj?.portfolioId) {
            this.modelEventData.parentObj.closeAndReopen(this.modelEventData.parentObj.portfolioId);
          }
        }
      }
    }
    super.cancel();
  }
  // helps in unit tests to set isModified flag
  public setIsModified(value: boolean): void {
    this.isModified = value;
  }
}
